// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"241":"2c253f75","258":"58ef4827","372":"e36c57c8","615":"d8aad2de","627":"342ecada","929":"92754f82"}[chunkId] + ".chunk.js";
};